export default "__VITE_ASSET__BxKwmcrl__"